import { cn } from "~/ui-rtk/utils/tailwind-utils"
import type { Momentum } from "../types"

const MOMENTUM_BADGE: Record<Momentum, { label: string; cls: string }> = {
  FATIGUING: { label: "Fatiguing", cls: "bg-red-600/30 text-red-300" },
  SCALING: { label: "Scaling", cls: "bg-green-600/30 text-green-300" },
  STABLE: { label: "Stable", cls: "bg-gray-600/30 text-gray-300" },
}

interface MomentumBadgeProps {
  momentum: Momentum
  /** Fired fatigue signals, shown in the tooltip */
  signals: string[]
}

export default function MomentumBadge({
  momentum,
  signals,
}: MomentumBadgeProps) {
  const badge = MOMENTUM_BADGE[momentum]
  return (
    <span
      title={
        signals.length > 0
          ? `Signals: ${signals.join(", ")}`
          : "No fatigue signals fired vs the prior 7 days"
      }
      className={cn("text-xs px-2 py-0.5 rounded-full font-medium", badge.cls)}
    >
      {badge.label}
    </span>
  )
}
